import { useState, useEffect } from 'react';

// 大型 AI Loading 區塊：跳動 emoji + 計時器 + 進度條 + 階段提示
export default function AILoadingIndicator({
  label = "AI 分析中",
  estimatedSeconds = 15,
  stages = null
}) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setSeconds(s => s + 1), 1000);
    return () => clearInterval(t);
  }, []);

  const progress = Math.min(95, (seconds / estimatedSeconds) * 100);
  const dots = '.'.repeat(seconds % 4);
  const mm = Math.floor(seconds / 60).toString();
  const ss = (seconds % 60).toString().padStart(2, '0');

  // 階段提示文字（若有提供 stages 陣列）
  let stageText = '';
  if (stages && stages.length > 0) {
    const ratio = seconds / estimatedSeconds;
    const idx = Math.min(stages.length - 1, Math.floor(ratio * stages.length));
    stageText = stages[idx];
  }

  return (
    <>
      <style>{`
        @keyframes ai-pulse { 0%, 100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.18); opacity: 0.65; } }
        @keyframes ai-shimmer { 0% { background-position: -300px 0; } 100% { background-position: 300px 0; } }
        .ai-load-bot { display: inline-block; font-size: 42px; animation: ai-pulse 1.4s ease-in-out infinite; }
        .ai-load-bar-bg { width: 100%; max-width: 360px; height: 8px; background: rgba(10, 18, 32, 0.8); border-radius: 4px; overflow: hidden; margin: 0 auto; border: 1px solid #1a2a40; }
        .ai-load-bar-fill { height: 100%; border-radius: 4px; background: linear-gradient(90deg, #1a6a96 0%, #7ec8e3 50%, #1a6a96 100%); background-size: 300px 100%; animation: ai-shimmer 1.8s linear infinite; transition: width 0.6s ease-out; box-shadow: 0 0 14px rgba(126, 200, 227, 0.6); }
      `}</style>
      <div style={{
        padding: 32,
        textAlign: 'center',
        background: 'linear-gradient(135deg, rgba(10, 22, 36, 0.6), rgba(13, 26, 42, 0.4))',
        border: '1px solid #2a4060',
        borderRadius: 12,
        margin: '8px auto',
        maxWidth: 480
      }}>
        <div className="ai-load-bot">🤖</div>

        <div style={{
          color: '#7ec8e3',
          fontSize: 17,
          fontWeight: 600,
          margin: '14px 0 6px',
          fontFamily: "'Rajdhani', sans-serif",
          letterSpacing: 3
        }}>
          {label}{dots}
        </div>

        {stageText && (
          <div style={{
            color: '#a8d0e8',
            fontSize: 12,
            marginBottom: 12,
            letterSpacing: 2,
            fontFamily: "'Rajdhani', sans-serif"
          }}>
            ({stageText})
          </div>
        )}

        <div style={{
          color: '#f0a500',
          fontSize: 32,
          fontWeight: 700,
          fontFamily: "'JetBrains Mono', monospace",
          marginBottom: 16,
          letterSpacing: 2
        }}>
          {mm}:{ss}
        </div>

        <div className="ai-load-bar-bg">
          <div className="ai-load-bar-fill" style={{ width: `${progress}%` }} />
        </div>

        <div style={{
          marginTop: 12,
          fontSize: 11,
          color: '#6a8090',
          fontFamily: "'Rajdhani', sans-serif",
          letterSpacing: 1.5
        }}>
          預估約 {estimatedSeconds} 秒
        </div>
      </div>
    </>
  );
}

// 小型計時器（給 button 內 inline 用）
export function InlineTimer({ prefix = "⏳ 分析中 " }) {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSeconds(s => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const mm = Math.floor(seconds / 60);
  const ss = (seconds % 60).toString().padStart(2, '0');
  return <>{prefix}{mm}:{ss}</>;
}
